<template lang="pug">
#modelAttr.comAll(v-dragDiv,v-show="!actionData.isMini")
  .title.moveDragDiv
    span {{actionData.cnName}}
    i.el-icon-minus.minibtn(title='最小化' @click='miniCom')
    i.el-icon-close(title='关闭' @click='closeAdd')
  .content
    el-tree.attrtree(:data='treedatas' :props='defaultProps' empty-text='请点击选择构件' v-slot="{ node, data }")
      .custom-tree-node(:title='node.label') {{ node.label }}
</template>

<script>
import mongeApiMlib from "@/CommonDP/mongeView/mongeApiMlib";
export default {
  props: {
    actionData: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  data () {
    return {
      defaultProps: {
        children: "children",
        label: "label"
      }
    };
  },
  computed: {
    treedatas() {
      return mongeApiMlib.getAttrTree();
    }
  },
  methods: {
    miniCom() {
      this.$emit("closeCom", 'modelAttr', true);
    },
    closeAdd() {
      this.$emit("closeCom", 'modelAttr', false);
    }
  }
};
</script>

<style lang="scss" scoped src="@/CommonDP/mongeView/common/common.scss" ></style>
<style lang="scss" scoped>
#modelAttr{
  position: fixed;
  top: 70px;
  left: 160px;
  width: 300px;
  height: calc(100% - 190px);
  max-height: 770px;
  .content{
    height: calc(100% - 40px);
    width: 100%;
    overflow-y: auto;
    padding:7px 14px;
  }
}
</style>
